(function () {
    let currentIndex = 0;
    const track = document.getElementById('galleryTrack');
    const prevBtn = document.getElementById('galleryPrev');
    const nextBtn = document.getElementById('galleryNext');
    const items = track ? track.querySelectorAll('.app-gallery-item') : [];
    const totalItems = items.length;

    function getVisibleItems() {
      if (window.innerWidth <= 480) return 1;
      if (window.innerWidth <= 768) return 2;
      if (window.innerWidth <= 1024) return 3;
      return 4;
    }

    function updateNav() {
      const visibleItems = getVisibleItems();
      const maxIndex = Math.max(0, totalItems - visibleItems);
      if (prevBtn) prevBtn.classList.toggle('disabled', currentIndex === 0);
      if (nextBtn) nextBtn.classList.toggle('disabled', currentIndex >= maxIndex);
    }

    window.slideGallery = function (direction) {
      const visibleItems = getVisibleItems();
      const maxIndex = Math.max(0, totalItems - visibleItems);

      currentIndex += direction;
      if (currentIndex < 0) currentIndex = 0;
      if (currentIndex > maxIndex) currentIndex = maxIndex;

      if (items.length > 0) {
        const itemWidth = items[0].offsetWidth;
        const gap = 20;
        const offset = -(currentIndex * (itemWidth + gap));
        track.style.transform = `translateX(${offset}px)`;
      }

      updateNav();
    };

    window.addEventListener('resize', () => {
      currentIndex = 0;
      if (track) track.style.transform = 'translateX(0)';
      updateNav();
    });

    updateNav();
  })();